import React from 'react'

const LoadingFallback = ({ message }) => <span>{message}</span>

LoadingFallback.defaultProps = {
  message: 'Chargement',
}

export default LoadingFallback
